
export default {
  socketUrl: process.env.REACT_APP_API,
  paymentGatewayUrl:`${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/api/v1/`,
  baseUrl: `${process.env.REACT_APP_API}/api/v1/`,
  imageUrl:"https://chatwork-messenger.s3.ap-south-1.amazonaws.com/media/",
  razorpayKeyId: process.env.REACT_APP_RAZORPAY_KEY_ID,
  hmacSalt: process.env.REACT_APP_HMAC_SALT,
};
